import { useMemo } from 'react';

import { Annotator } from '@repo/image-annotator/lib';
import { useAtomValue } from 'jotai';

import type { ImageAnalyses } from '../../../../@types/latestImagesV2';
import { binFilterAtom } from '../../../annotator/findingSidebar/confidenceScoreFilter/atoms';

import { getFindings } from './helpers';

export const ImageThumbnail = ({
  image,
  height,
  width,
  enabledFindings,
  includedTeethIds,
  showIncipientCariesRed,
}: {
  image: ImageAnalyses;
  height: number;
  width: number;
  enabledFindings: string[];
  includedTeethIds?: string[];
  showIncipientCariesRed?: boolean;
}) => {
  const binFilterValue = useAtomValue(binFilterAtom);

  const annotatorFindings = useMemo(() => {
    const options = {
      cariesBin: binFilterValue,
      enabledFindings,
      includedTeethIds,
      showIncipientCariesRed,
    };
    const findings = getFindings(image, options);

    return findings;
  }, [
    image,
    binFilterValue,
    enabledFindings,
    includedTeethIds,
    showIncipientCariesRed,
  ]);

  return (
    <Annotator
      id={image.imageId}
      annotations={annotatorFindings}
      imageSrc={image.path ?? image.originalPath ?? ''}
      height={height}
      width={width}
      borderBackgroundColor="none"
    />
  );
};
